import { createSxStyles } from "@common/createSxStyles";

// The column a party sits in is what narrows the form, so the segment fills the column and this keeps the content
// on the same share of the card whether the two lists sit side by side or stacked.
export const counterPartiesStepStyles = createSxStyles({
    partyContent: {
        width: "90%",
        marginX: "auto",
    },
});
